import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import ACTIONS from '../../../store/actions';
import load from './load';
import { gridDataSelector } from '../../selectors/grid';
export var changeSort = function changeSort(props) {
  return function (dispatch, getState) {
    var id = props.id,
        sort = props.sort,
        by = props.by;
    var state = getState();
    var view = state.grid.views[id];
    var newSort = view.sort;
    var newBy = view.by;
    if (!sort) newSort = view.sort === 'desc' ? 'asc' : 'desc';
    if (sort) newSort = sort;
    if (by) newBy = by;
    var newSortColumn = props.grid.columns.find(function (c) {
      return c.id === newBy;
    });
    var newAll = {}; //reset

    if (view.count) {
      if (view.by === newBy && view.sort !== newSort) {
        //reverse sort direction
        newAll = {};

        for (var idx in view.all) {
          newAll[view.count - 1 - idx] = view.all[idx];
        }
      } else {
        if (view.fullyLoaded) {
          if (newSortColumn && newSortColumn.inMemorySort) {
            var itemSortValFn = newSortColumn.inMemorySort;
            if (typeof itemSortValFn === 'boolean') itemSortValFn = function itemSortValFn(data) {
              return data[newBy];
            }; //when all items are loaded, sort can be simulated in memory

            var gridData = gridDataSelector(state, {
              id: id
            });
            var loadedItems = [];

            for (var itemIdx in view.all) {
              var itemId = view.all[itemIdx];

              if (gridData[itemId]) {
                loadedItems.push({
                  id: itemId,
                  data: gridData[itemId]
                });
              }
            }

            var compare = function compare(a, b) {
              if (a < b) return -1;
              if (a > b) return 1;
              return 0;
            };

            var ordered = loadedItems.sort(function (a, b) {
              var comparison = compare(itemSortValFn(a.data), itemSortValFn(b.data));
              if (newSort === 'desc') return -comparison;
              return comparison;
            });
            ordered.map(function (item, idx) {
              return newAll[idx] = item.id;
            });
          }
        }
      }
    }

    var newView = {
      id: id,
      all: newAll,
      by: newBy,
      sort: newSort,
      page: 0
    };

    if (newSortColumn && newSortColumn.serverSort) {
      return dispatch(load(_objectSpread({}, props, newView)));
    } else {
      return dispatch({
        type: ACTIONS.GRID_VIEW_SET,
        view: newView
      });
    }
  };
};
export default changeSort;